import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs as importedSave } from 'file-saver';
import {ClientITProfile, ComplianceArea, Project} from '../../_models';
import { ApiKey } from '../../_models/apiKey';
import { ApiKeyService } from '../../_services/apiKey.service';
import {
  AlertService,
  AuthenticationService,
  ClientProfileService, ComplianceAreaService, IntegrationsService,
  ProjectService,
} from '../../_services/index';
import { IndexConfigService } from '../../_services/index.config.service';
import { SapProfileService } from '../../_services/sapProfile.service';
import { SarProfileService } from '../../_services/sarProfile.service';
import { LoginHelper } from '../../helpers';
import {Integration} from "../../_models/integration";
import { Constants } from '../../helpers/constants';

@Component({
    standalone: false,
  selector: 'integrations-component',
  templateUrl: 'integrations.component.html',
  styleUrls: ['./integrations.component.scss'],
})
export class IntegrationsComponent implements OnInit {
  apiKeys: ApiKey[];
  msg: string;
  error: any = {};
  success: any = {};
  model: any = {
    evidence: <any>{},
    dictionary: <any>{},
    getActionPlan: <any>{ actionPlan: <any>{ attachments: [<any>{}] } },
    actionPlan: <any>{ actionPlan: <any>{ attachments: [<any>{}] } },
    catalog: <any>{},
    profile: <any>{},
    profileCategory: <any>{},
    implementation: <any>{apiKey:'b2e225d3-27f3-42d8-9d23-f9e6de4a2b88', projectName: 'Fedramp export', itProfileName: 'FedRAMP Profile33', fedramplevel: 'high', isrlink: false, isdummyrlink: false, tenantName: 'test26'},
    validation: <any>{apiKey: location.hostname === 'localhost' ? 'b2e225d3-27f3-42d8-9d23-f9e6de4a2b88' : null, tenantName: 'test26'},
    implementation_ext: <any>{},
    poam: <any>{},
    sap: <any>{},
    sar: <any>{},
  };
  validationData: any;
  validationTotal: any;
  file: File;
  dictionaryFile: File;
  projects: Project[] = [];
  itProfiles: ClientITProfile[] = [];
  sapProfiles: any[] = [];
  sarProfiles: any[] = [];
  complianceAreas: ComplianceArea[] = [];
  integrations: Integration[] = [];
  tenantName = LoginHelper.getTenantName();

  cols: any[] = [{ 'field': 'key', 'header': 'Key' }];
  dictionariesJsonCode = "{\n" +
    "  \"vendors\": [\n" +
    "    {\n" +
    "      \"name\": \"AWS\",\n" +
    "      \"url\": \"https://amazon.com\",\n" +
    "      \"guidance\": \"Guidance text\",\n" +
    "      \"services\": [\n" +
    "        {\n" +
    "          \"name\": \"Amazon Cloud\",\n" +
    "          \"customerResponsibilities\": \"Responsibilities Text\",\n" +
    "          \"implementationDetails\": \"Implementation Data\"\n" +
    "        },\n" +
    "        {\n" +
    "          \"name\": \"AWS\",\n" +
    "          \"customerResponsibilities\": \"Responsibilities Text\",\n" +
    "          \"implementationDetails\": \"Implementation Data\"\n" +
    "        }\n" +
    "      ]\n" +
    "    },\n" +
    "    {\n" +
    "      \"name\": \"Azure\",\n" +
    "      \"url\": \"https://azure.com\",\n" +
    "      \"guidance\": \"Guidance text\",\n" +
    "      \"services\": [\n" +
    "        {\n" +
    "          \"name\": \"Azure Functions\",\n" +
    "          \"customerResponsibilities\": \"Responsibilities Text\",\n" +
    "          \"implementationDetails\": \"Implementation Data\"\n" +
    "        }\n" +
    "      ]\n" +
    "    }\n" +
    "  ]\n" +
    "}\n";
  constants = Constants;

  constructor(
    public http: HttpClient,
    public route: ActivatedRoute,
    public router: Router,
    public apiKeyService: ApiKeyService,
    public indexConfigService: IndexConfigService,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public clientProfileService: ClientProfileService,
    public sapProfileService: SapProfileService,
    public sarProfileService: SarProfileService,
    public integrationService: IntegrationsService,
    public alertService: AlertService,
    public complianceAreaService: ComplianceAreaService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.projectService.getAllShort().subscribe((p) => {
      this.projects = p;
      this.clientProfileService.getClientProfiles(tenantName).subscribe((s) => {
        this.itProfiles = s;
        p.forEach((project) => {
          (<any>project).itProfiles = (project.clientITProfileIds || '')
            .split(';')
            .map((id) => s.find((pr) => pr.clientITProfileId == id))
            .filter((a) => a);
        });
      });
    });

    this.complianceAreaService.getInfoComplianceAreas().subscribe(complianceAreas => {
      this.complianceAreas = complianceAreas;
    });

    this.sapProfileService
      .getSapProfiles()
      .subscribe((s) => (this.sapProfiles = s));
    this.sarProfileService
      .getSarProfiles()
      .subscribe((s) => (this.sarProfiles = s));

    this.integrationService.getAll().subscribe(i => this.integrations = i);

    this.model['dictionary'].tenantName = tenantName;
    this.model['evidence'].tenantName = tenantName;
    this.model['getActionPlan'].tenantName = tenantName;
    this.model['actionPlan'].tenantName = tenantName;
    this.model['catalog'].tenantName = tenantName;
    this.model['profile'].tenantName = tenantName;
    this.model['profileCategory'].tenantName = tenantName;
    this.model['implementation'].tenantName = tenantName;
    this.model['validation'].tenantName = tenantName;
    this.model['poam'].tenantName = tenantName;
    this.model['sap'].tenantName = tenantName;
    this.model['sar'].tenantName = tenantName;
  }

  fileSelected(event) {
    this.file = event.target.files[0];
  }

  dictionaryFileSelected(event) {
    this.dictionaryFile = event.target.files[0];
  }

  sendEvidence() {
    let formData = new FormData();
    formData.append('apiKey', this.model['evidence'].apiKey);
    formData.append('tenantName', this.model['evidence'].tenantName);
    formData.append('projectName', this.model['evidence'].projectName);
    formData.append('controlItemId', this.model['evidence'].controlItemId);
    formData.append(
      'complianceAreaName',
      this.model['evidence'].complianceAreaName
    );
    formData.append(this.file.name, this.file, this.file.name);

    this.error['evidence'] = '';
    this.success['evidence'] = '';

    this.http
      .post(
        this.indexConfigService.externalApi +
        '/api/projectcontrolitem/evidence',
        formData/*, {
          headers: new HttpHeaders({
            'Content-Type': 'multipart/form-data'
          })
        }*/
      )
      .subscribe(
        (r) => {
          this.success['evidence'] = 'Successfully added as ' + r;
        },
        (e) => {
          this.error['evidence'] = e;
        }
      );
  }

  sendDictionary() {
    let formData = new FormData();
    formData.append('apiKey', this.model['dictionary'].apiKey);
    formData.append('tenantName', this.model['dictionary'].tenantName);
    formData.append(this.dictionaryFile.name, this.dictionaryFile, this.dictionaryFile.name);

    this.error['dictionary'] = '';
    this.success['dictionary'] = '';

    this.http
      .post(
        this.indexConfigService.externalApi +
        '/api/dictionary',
        formData/*, {
          headers: new HttpHeaders({
            'Content-Type': 'multipart/form-data'
          })
        }*/
      )
      .subscribe(
        (r) => {
          this.success['dictionary'] = 'Successfully added';
        },
        (e) => {
          this.error['dictionary'] = e;
        }
      );
  }

  sendProjectPoam() {
    this.error['actionPlan'] = '';
    this.success['actionPlan'] = '';

    this.http
      .post(
        this.indexConfigService.externalApi +
        `/api/projectcontrolitem/poam?apiKey=${
          this.model['actionPlan'].apiKey
        }&tenantName=${LoginHelper.getTenantName()}`,
        this.model['actionPlan']['actionPlan'],
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          this.success['actionPlan'] = 'Successfully added as ' + r;
        },
        (e) => {
          this.error['actionPlan'] = e;
        }
      );
  }

  getProjectPoam() {
    this.error['getActionPlan'] = '';
    this.success['getActionPlan'] = '';

    this.http
      .get(
        this.indexConfigService.externalApi +
        `/api/projectcontrolitem/poam?apiKey=${
          this.model['getActionPlan'].apiKey
        }&tenantName=${LoginHelper.getTenantName()}&projectName=${this.model['getActionPlan']['actionPlan'].projectName}&complianceAreaName=${this.model['getActionPlan']['actionPlan'].complianceAreaName}&controlItemId=${this.model['getActionPlan']['actionPlan'].controlItemId}&name=${this.model['getActionPlan']['actionPlan'].name}`
      )
      .subscribe(
        (r) => {
          this.success['getActionPlan'] = r;
        },
        (e) => {
          this.error['getActionPlan'] = e;
        }
      );
  }

  sendCatalog() {
    this.error['catalog'] = '';
    this.success['catalog'] = '';

    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/catalog/xml?apiKey=' +
          this.model['catalog'].apiKey +
          '&complianceArea=' +
          this.model['catalog'].complianceArea +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'catalog_' + this.model['catalog'].complianceArea + '.xml'
          );
          this.success['catalog'] = 'Success';
        },
        (e) => {
          this.error['catalog'] = e;
        }
      );
  }

  sendProfile() {
    this.error['profile'] = '';
    this.success['profile'] = '';

    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/profile/xml?apiKey=' +
          this.model['profile'].apiKey +
          '&projectName=' +
          this.model['profile'].projectName +
          '&mergeSection=' +
          (this.model['profile'].mergeSection ? 'true' : 'false') +
          '&modifySection=' +
          (this.model['profile'].modifySection ? 'true' : 'false') +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'profile_' + this.model['profile'].projectName
          );
          this.success['profile'] = 'Success';
        },
        (e) => {
          this.error['profile'] = e;
        }
      );
  }

  sendProfileCategory() {
    this.error['profileCategory'] = '';
    this.success['profileCategory'] = '';

    this.alertService.loading.next(true);
    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/profile/xml?apiKey=' +
          this.model['profileCategory'].apiKey +
          '&projectName=' +
          this.model['profileCategory'].projectName +
          '&category=' +
          this.model['profileCategory'].category +
          '&mergeSection=' +
          (this.model['profileCategory'].mergeSection ? 'true' : 'false') +
          '&modifySection=' +
          (this.model['profileCategory'].modifySection ? 'true' : 'false') +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'applicayion/xml' }),
            'profile_' +
              this.model['profileCategory'].projectName +
              '_' +
              this.model['profileCategory'].category
          );
          this.alertService.loading.next(false);
          this.success['profileCategory'] = 'Success';
        },
        (e) => {
          this.alertService.loading.next(false);
          this.error['profileCategory'] = e;
        }
      );
  }

  sendImplementation() {
    this.error['implementation'] = '';
    this.success['implementation'] = '';

    this.alertService.loading.next(true);
    this.model['implementation'].projectName =
      this.model['implementation_ext'].project.name;
    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/implementation/xml?apiKey=' +
          this.model['implementation'].apiKey +
          '&projectName=' +
          this.model['implementation'].projectName +
          '&itProfileName=' +
          this.model['implementation'].itProfileName +
          '&fedramplevel=' +
          this.model['implementation'].fedrampLevel +
          '&isrlink=' +
          this.model['implementation'].isRlink +
          '&isdummyrlink=' +
          (this.model['implementation'].dummyRlink || false) +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'implementation_' + this.model['implementation'].projectName
          );
          this.alertService.loading.next(false);
          this.success['implementation'] = 'Success';
        },
        (e) => {
          this.alertService.loading.next(false);
          this.error['implementation'] = e;
        }
      );
  }

  sendPoam() {
    this.error['poam'] = '';
    this.success['poam'] = '';

    this.alertService.loading.next(true);
    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/poam/xml?apiKey=' +
          this.model['poam'].apiKey +
          '&projectName=' +
          this.model['poam'].projectName +
          '&isrlink=' +
          this.model['poam'].isRlink +
          '&isdummyrlink=' +
          (this.model['poam'].dummyRlink || false) +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'poam' + this.model['poam'].projectName
          );
          this.alertService.loading.next(false);
          this.success['poam'] = 'Success';
        },
        (e) => {
          this.alertService.loading.next(false);
          this.error['poam'] = e;
        }
      );
  }

  sendSap() {
    this.error['sap'] = '';
    this.success['sap'] = '';

    this.alertService.loading.next(true);
    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/sap/xml?apiKey=' +
          this.model['sap'].apiKey +
          '&profileName=' +
          this.model['sap'].profileName +
          '&isrlink=' +
          (this.model['sap'].isRlink || false) +
          '&isdummyrlink=' +
          (this.model['sap'].dummyRlink || false) +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'sap' + this.model['sap'].projectName
          );
          this.alertService.loading.next(false);
          this.success['sap'] = 'Success';
        },
        (e) => {
          this.alertService.loading.next(false);
          this.error['sap'] = e;
        }
      );
  }

  sendSar() {
    this.error['sar'] = '';
    this.success['sar'] = '';

    this.alertService.loading.next(true);
    this.http
      .get(
        this.indexConfigService.externalApi +
          '/api/oscal/sar/xml?apiKey=' +
          this.model['sar'].apiKey +
          '&profileName=' +
          this.model['sar'].profileName +
          '&sapProfileName=' +
          this.model['sar'].sapProfileName +
          '&isrlink=' +
          (this.model['sar'].isRlink || false) +
          '&isdummyrlink=' +
          (this.model['sar'].dummyRlink || false) +
          '&tenantName=' +
          LoginHelper.getTenantName(),
        { responseType: 'arraybuffer' }
      )
      .subscribe(
        (r) => {
          importedSave(
            new Blob([r], { type: 'application/xml' }),
            'sar' + this.model['sar'].projectName
          );
          this.alertService.loading.next(false);
          this.success['sar'] = 'Success';
        },
        (e) => {
          this.alertService.loading.next(false);
          this.error['sar'] = e;
        }
      );
  }

  validateImplementationFileSelected(event) {
    this.file = event.target.files[0];
  }

  validateImplementationSendEvidence() {
    let formData = new FormData();
    formData.append('apiKey', this.model['validation'].apiKey);
    formData.append('tenantName', this.model['validation'].tenantName);
    formData.append(this.file.name, this.file, this.file.name);
    this.validationData = null;
    this.alertService.loading.next(true);

    this.http
      .post(
        this.indexConfigService.externalApi +
        '/api/oscal/implementation/validate',
        formData/*, {
          headers: new HttpHeaders({
            'Content-Type': 'multipart/form-data'
          })
        }*/
      )
      .subscribe(
        (r) => {
          this.alertService.loading.next(false);
          this.validationData = [];
          this.validationTotal = 0;
          const results = JSON.parse(r['response']).runs[0].results;
          if (results) {
            const data = results.map(r => ({ ranges : r.locations, error: r.message.text}));
            let map = {};
            data.forEach((e) => {
              if (!map[e.error]) {
                map[e.error] = map[e.error] || [];
                this.validationData.push({error: e.error, ranges: map[e.error]});
              }
              this.validationTotal += e.ranges.length;
              e.ranges.forEach((a) => map[e.error].push(a));
            });
          }
        },
        (e) => {
          this.alertService.loading.next(false);
        }
      );
  }

  sendProjectPoamToIntegration(){

  }
}
